<template>
	<!-- data-bs-pause="false" -->
	<div
		id="carouselPublicidad"
		class="carousel slide carousel-dark"
		style="width: 100% !important"
		data-bs-ride="carousel"
		data-bs-interval="5000"
		data-bs-pause="hover"
	>
	
		<div class="carousel-inner">
			<div
				v-for="(imageGroup, index) in this.carouselImages"
				:key="index"
				class="carousel-item"
				:class="{ active: index === 0 }"
			>
				<div class="grid-container">
					<PubliciteAqui
						class="grid-item"
						v-if="imageGroup.length == 1"
					/>

					<div
						class="grid-item"
						v-for="(image, index) in imageGroup"
						:key="index"
					>
						<img :src="image.url" alt="Photo 1" class="photo" />
					</div>

					<PubliciteAqui
						class="grid-item"
						v-if="imageGroup.length == 1 || imageGroup.length == 2"
					/>
				</div>
			</div>

			<div class="carousel-item" v-if="!this.publiciteAquiShow">
				<div class="grid-container">
					<PubliciteAqui class="grid-item" />
					<PubliciteAqui class="grid-item" />
					<PubliciteAqui class="grid-item" />
				</div>
			</div>
		</div>

		<button
			class="carousel-control-prev"
			type="button"
			data-bs-target="#carouselPublicidad"
			data-bs-slide="prev"

			v-if="this.carouselImages.length > 1 || !this.publiciteAquiShow"
		>
			<span class="carousel-control-prev-icon" aria-hidden="true"></span>
			<span class="visually-hidden">Previous</span>
		</button>
		<button
			class="carousel-control-next"
			type="button"
			data-bs-target="#carouselPublicidad"
			data-bs-slide="next"

			v-if="this.carouselImages.length > 1 || !this.publiciteAquiShow"
		>
			<span class="carousel-control-next-icon" aria-hidden="true"></span>
			<span class="visually-hidden">Next</span>
		</button>
	</div>
</template>

<script>
import axios from "axios";
import { backend_url } from "@/services/ApiReq";
import PubliciteAqui from "./PubliciteAqui.vue";

export default {
	beforeMount() {},
	async mounted() {
		await this.fetchCarouselImages();

		console.log("Publicidad images:", this.carouselImages);
	},
	components: {
		PubliciteAqui,
	},
	computed: {
		Backend() {
			return backend_url;
		},
	},
	methods: {
		async fetchCarouselImages() {
			try {
				const response = await axios.get(
					`${process.env.VUE_APP_BACKEND_URL}/galerias/nombre/Publicidad`
				);

				if (
					response.data.success &&
					Array.isArray(response.data.data)
				) {
					const gallery = response.data.data[0];
					if (gallery && Array.isArray(gallery.files)) {
						const images = gallery.files.map((file) => ({
							url: `${file.url.replace("public/", "")}`,
							alt: file.name || "Carousel image",
							link: "#",
						}));

						const chunkSize = 3;
						const chunkedImages = [];
						for (let i = 0; i < images.length; i += chunkSize)
							chunkedImages.push(images.slice(i, i + chunkSize));

						this.publiciteAquiShow = chunkedImages.some(subarray => subarray.length < 3);
						this.carouselImages = chunkedImages;
					} else {
						console.error("No files found in the gallery");
						this.carouselImages = [];
					}
				} else {
					console.error(
						"Unexpected API response format:",
						response.data
					);
					this.carouselImages = [];
				}
			} catch (error) {
				console.error("Error fetching publicity images:", error);
				this.carouselImages = [];
			}
		},
	},
	data: () => {
		return {
			carouselImages: [],
			publiciteAquiShow: true,
		};
	},
};
</script>

<style scoped>
.carousel {
	width: 100% !important;
}

.carousel-item {
	padding-left: 0.5rem;
}

.grid-container {
	width: 100%;

	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 0.5rem;
}

.grid-item {
	/* aspect-ratio: 1.1006441223832528; */
	aspect-ratio: 1 / 1;
	position: relative;
}

.photo {
	height: 100%;
	width: 100%;

	position: absolute;
	top: 0;
	left: 0;
	/* object-fit: cover; */
	object-fit: contain;
}
</style>
